var _defineProperty = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var integration = require('../integration.js');
var path = require('../utils-hoist/path.js');
var worldwide = require('../utils-hoist/worldwide.js');
var INTEGRATION_NAME = 'RewriteFrames';

/**
 * Rewrite event frames paths.
 */
var rewriteFramesIntegration = integration.defineIntegration(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var root = options.root;
  var prefix = options.prefix || 'app:///';
  var isBrowser = 'window' in worldwide.GLOBAL_OBJ && !!worldwide.GLOBAL_OBJ.window;
  var iteratee = options.iteratee || generateIteratee({
    isBrowser: isBrowser,
    root: root,
    prefix: prefix
  });

  /** Process an exception event. */
  function _processExceptionsEvent(event) {
    try {
      return _objectSpread(_objectSpread({}, event), {}, {
        exception: _objectSpread(_objectSpread({}, event.exception), {}, {
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(function (value) {
            return _objectSpread(_objectSpread({}, value), value.stacktrace && {
              stacktrace: _processStacktrace(value.stacktrace)
            });
          })
        })
      });
    } catch (_oO) {
      return event;
    }
  }

  /** Process a stack trace. */
  function _processStacktrace(stacktrace) {
    return _objectSpread(_objectSpread({}, stacktrace), {}, {
      frames: (stacktrace === null || stacktrace === void 0 ? void 0 : stacktrace.frames) && stacktrace.frames.map(function (f) {
        return iteratee(f);
      })
    });
  }
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(originalEvent) {
      var processedEvent = originalEvent;
      if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
        processedEvent = _processExceptionsEvent(processedEvent);
      }
      return processedEvent;
    }
  };
});

/**
 * Exported only for tests.
 */
function generateIteratee(_ref) {
  var isBrowser = _ref.isBrowser,
    root = _ref.root,
    prefix = _ref.prefix;
  return function (frame) {
    if (!frame.filename) {
      return frame;
    }

    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) ||
    // or the presence of a backslash without a forward slash (which are not allowed on Windows)
    frame.filename.includes('\\') && !frame.filename.includes('/');

    // Check if the frame filename begins with `/`
    var startsWithSlash = /^\//.test(frame.filename);
    if (isBrowser) {
      if (root) {
        var oldFilename = frame.filename;
        if (oldFilename.indexOf(root) === 0) {
          frame.filename = oldFilename.replace(root, prefix);
        }
      }
    } else {
      if (isWindowsFrame || startsWithSlash) {
        var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
        .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
        var base = root ? path.relative(root, filename) : path.basename(filename);
        frame.filename = "".concat(prefix).concat(base);
      }
    }
    return frame;
  };
}
exports.generateIteratee = generateIteratee;
exports.rewriteFramesIntegration = rewriteFramesIntegration;